import React from "react";

export default {
  facebook: (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 18.14 32.52"
    >
      <title>facebook-icon2</title>
      <path
        d="M28.82,3.6A25.21,25.21,0,0,0,23.66,3c-2.67,0-4.56.45-6,1.52a5.26,5.26,0,0,0-2.18,                                  4v7.93H10.69v4.84h4.78V35.52h6.77V21.26h5.54l0.4-4.86h-6l0.08-6.65S22.4,7.24,28,8.61c0.33-2.12.85-5,.85-5"
        transform="translate(-10.69 -3)"
      />
    </svg>
  ),
  googleplus: (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 448 384.1"
    >
      <title>google-icon</title>
      <path
        d="M242.1,275.6l-18.2-13.7-0.1-.1c-5.8-4.6-10-8.3-10-14.7,0-7,5-11.8,10.9-17.4l0.5-.4c20-15.2,44.7-34.3,44.7-74.6,0-26.9-11.9-44.7-23.3-57.7h13L320,64H186.5c-25.3,0-62.7,3.2-94.6,28.6l-0.1.3C70,110.9,57,137.4,57,163.5a81.93,81.93,0,0,0,23.9,57.4C102.3,242.5,129.2,247,148,247c1.5,0,3,0,4.5-.1a39.38,39.38,0,0,0-1.2,10.3,46.56,46.56,0,0,0,8.1,26.2c-24,1.9-58.1,6.5-84.9,22.3C35.1,328.4,32,361.7,32,371.3c0,38.2,35.7,76.8,115.5,76.8,91.6,0,139.5-49.8,139.5-99C287,312,264.2,293.5,242.1,275.6ZM116.7,139.9c0-13.4,3-23.5,9.3-30.9,6.5-7.9,18.2-13.1,29-13.1,19.9,0,32.9,15,40.4,27.6,9.2,15.5,14.9,36.1,14.9,53.6,0,4.9,0,20-10.2,29.8-7,6.7-18.7,11.4-28.6,11.4-20.5,0-33.5-14.7-40.7-27A108,108,0,0,1,116.7,139.9ZM237.8,368c0,27.4-25.2,44.5-65.8,44.5-48.1,0-80.3-20.6-80.3-51.3,0-26.1,21.5-36.8,37.8-42.5,18.9-6.1,44.3-7.3,50.1-7.3,3.9,0,6.1,0,8.7.2C224.9,336.8,237.8,347.7,237.8,368Z"
        transform="translate(-32 -64)"
      />
      <polygon points="370 78 370 0 336 0 336 78 256 78 256 112 336 112 336 193 370 193 370 112 448 112 448 78 370 78" />
    </svg>
  ),
  linkedin: (
    <svg
      enableBackground="new 0 0 512 512"
      height="512px"
      id="Слой_1"
      version="1.1"
      viewBox="0 0 512 512"
      width="512px"
    >
      <path
        d="M125.016,62.969c0,34.797-27.983,62.985-62.517,62.985C28,125.954,0,97.766,0,62.969  C0,28.203,28,0,62.499,0C97.032,0,125.016,28.203,125.016,62.969z M115.874,170.641H10.156V512h105.718V170.641z M284.844,170.641  H183.468V512h101.376c0,0,0-126.609,0-179.188c0-48,22.107-76.563,64.404-76.563c38.875,0,57.563,27.422,57.563,76.563  c0,49.172,0,179.188,0,179.188H512c0,0,0-124.719,0-216.125c0-91.468-51.846-135.641-124.252-135.641  c-72.422,0-102.904,56.407-102.904,56.407V170.641L284.844,170.641z"
        id="Linkedin_1_"
      />
    </svg>
  ),
  pinterest: (
    <svg
      id="Layer_5"
      data-name="Layer 5"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 33.1 33.1"
    >
      <title>pinterest-icon</title>
      <path
        d="M20.12,3.71a16.55,16.55,0,0,0-6,32,15.91,15.91,0,0,1,.06-4.75c0.3-1.29,1.94-8.23,1.94-8.23a6,6,0,0,1-.5-2.46c0-2.3,1.33-4,3-4a2.08,2.08,0,0,1,2.09,2.33c0,1.42-.9,3.54-1.37,5.51a2.4,2.4,0,0,0,2.45,3c2.94,0,5.2-3.1,5.2-7.58A6.53,6.53,0,0,0,20,12.74a7.16,7.16,0,0,0-7.47,7.18,6.43,6.43,0,0,0,1.23,3.78,0.5,0.5,0,0,1,.12.47l-0.46,1.88c-0.07.3-.24,0.37-0.55,0.22-2.07-1-3.36-4-3.36-6.41,0-5.22,3.79-10,10.94-10,5.74,0,10.2,4.09,10.2,9.56,0,5.7-3.6,10.29-8.59,10.29a4.43,4.43,0,0,1-3.79-1.9l-1,3.93a18.53,18.53,0,0,1-2.06,4.34A16.55,16.55,0,1,0,20.12,3.71Z"
        transform="translate(-3.57 -3.71)"
      />
    </svg>
  ),
  twitter: (
    <svg
      id="Layer_4"
      className="twitter-x"
      data-name="Layer 4"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 1400 1000"
      enableBackground="new 0 0 1400 1000"
    >
      <g id="layer1">
        <path
          d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
          h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"
          transform="translate(52.390088,-25.058597)"
        />
      </g>
    </svg>
  ),
  youtube: (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
    >
      <g>
        <path d="M685.3,501.3l-276.4,181c-3.3,2.2-7.1,3.3-11,3.3c-3.4,0-6.7-0.8-9.8-2.5c-6.5-3.7-10.6-10.7-10.6-18.3v-362c0-7.6,4.1-14.7,10.6-18.3c6.6-3.7,14.5-3.4,20.8,0.7l276.4,181c5.9,3.8,9.4,10.5,9.4,17.6C694.7,490.8,691.2,497.5,685.3,501.3 M829.2,144.8H170.8C82.2,144.8,10,218.7,10,309.4v381.2c0,90.8,72.2,164.6,160.8,164.6h658.4c88.6,0,160.8-73.8,160.8-164.6V309.4C990,218.7,917.8,144.8,829.2,144.8" />
      </g>
    </svg>
  ),
  instagram: (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="https://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="510px"
      height="510px"
      viewBox="0 0 510 510"
      enableBackground="new 0 0 510 510"
    >
      <g>
        <g id="post-instagram">
          <path d="M459,0H51C22.95,0,0,22.95,0,51v408c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0zM255,153c56.1,0,102,45.9,102,102c0,56.1-45.9,102-102,102c-56.1,0-102-45.9-102-102C153,198.9,198.9,153,255,153z M63.75,459C56.1,459,51,453.9,51,446.25V229.5h53.55C102,237.15,102,247.35,102,255c0,84.15,68.85,153,153,153c84.15,0,153-68.85,153-153c0-7.65,0-17.85-2.55-25.5H459v216.75c0,7.65-5.1,12.75-12.75,12.75H63.75z M459,114.75c0,7.65-5.1,12.75-12.75,12.75h-51c-7.65,0-12.75-5.1-12.75-12.75v-51c0-7.65,5.1-12.75,12.75-12.75h51C453.9,51,459,56.1,459,63.75V114.75z" />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  ),
};



// WEBPACK FOOTER //
// ./src/components/shared/social/icons.js